import { FC } from "react";
import { CircularProgress as MuiCircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledCircularProgress = styled(MuiCircularProgress)(({ theme }) => ({
  color: theme.colors.sapphire,
}));

interface CircularProgressProps {
  thickness?: number;
  size?: number;
}

const CircularProgress: FC<CircularProgressProps> = ({
  thickness = 2,
  size = 75,
}) => {
  return <StyledCircularProgress thickness={thickness} size={size} />;
};

export default CircularProgress;
